import React from 'react'

import '../css/PhotoLoader.css'

import MyPic from '../images/MyPic.jpeg'
import ContactInfoCard from './ContactInfoCard'

const PhotoLoader = () => {
  return (
    <div className='PhotoLoader'>
        <img src={MyPic} alt='MyPic' className='photo' />
        <ContactInfoCard/>
    </div>
  )
}

export default PhotoLoader